const Variables = (() => {
  const Variables = {
    prefix: "nhw",
  };

  return Variables;
})();

export default Variables;
